import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';

const Dashboard = ({ onLogout }) => {
    return <DashboardLayout onLogout={onLogout} />;
}

export default Dashboard;
